import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { EmailTemplateList } from '@/components/superadmin/EmailTemplateList';
import { Mail, Shield, ArrowLeft } from 'lucide-react';

const SuperAdminEmails = () => {

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="container mx-auto px-4 py-8">
        <Link to="/superadmin">
          <Button variant="outline" className="flex items-center gap-2 mb-4">
            <ArrowLeft className="h-4 w-4" />
            Back to Super Admin
          </Button>
        </Link>
        
        <div className="mb-8">
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <Shield className="h-8 w-8 text-red-600" />
            Email Templates
          </h1>
          <p className="text-muted-foreground mt-2">
            View and manage email templates used for user registration and authentication
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Mail className="h-5 w-5" />
              System Email Templates
            </CardTitle>
            <CardDescription>
              Email templates used for user registration, password reset, and confirmation emails
            </CardDescription>
          </CardHeader>
          <CardContent>
            <EmailTemplateList />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SuperAdminEmails;